/**
 * @generated SignedSource<<9baa1b49b3434e32fe1f9d06b8bb284d>>
 * @relayHash 2f9e8a56209f656e7990be5b9505a742
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f9e8a56209f656e7990be5b9505a742

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoimmuneDisease = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES";
export type Cancer = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES";
export type Diabetes = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES_DIABETES_TYPE_ONE" | "YES_DIABETES_TYPE_ONE_AND_TWO" | "YES_DIABETES_TYPE_TWO";
export type HeartDisease = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES";
export type De_updatePatientFamilyHistoryInput = {
  autoimmuneDisease: AutoimmuneDisease;
  cancer: Cancer;
  comment?: string | null;
  diabetes: Diabetes;
  heartDisease: HeartDisease;
  patientId: string;
};
export type deUpdatePatientFamilyHistoryMutation$variables = {
  input: De_updatePatientFamilyHistoryInput;
};
export type deUpdatePatientFamilyHistoryMutation$data = {
  readonly updatePatientFamilyHistory: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly patientId?: string;
    }> | null;
    readonly familyHistory: {
      readonly " $fragmentSpreads": FragmentRefs<"FamilyHistoryFragment">;
    } | null;
  };
};
export type deUpdatePatientFamilyHistoryMutation = {
  response: deUpdatePatientFamilyHistoryMutation$data;
  variables: deUpdatePatientFamilyHistoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/)
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "PatientNotFound",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deUpdatePatientFamilyHistoryMutation",
    "selections": [
      {
        "alias": "updatePatientFamilyHistory",
        "args": (v1/*:: as any*/),
        "concreteType": "De_updatePatientFamilyHistoryPayload",
        "kind": "LinkedField",
        "name": "de_updatePatientFamilyHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FamilyHistory",
            "kind": "LinkedField",
            "name": "familyHistory",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FamilyHistoryFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deUpdatePatientFamilyHistoryMutation",
    "selections": [
      {
        "alias": "updatePatientFamilyHistory",
        "args": (v1/*:: as any*/),
        "concreteType": "De_updatePatientFamilyHistoryPayload",
        "kind": "LinkedField",
        "name": "de_updatePatientFamilyHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FamilyHistory",
            "kind": "LinkedField",
            "name": "familyHistory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoimmuneDisease",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cancer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heartDisease",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diabetes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "comment",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2f9e8a56209f656e7990be5b9505a742",
    "metadata": {},
    "name": "deUpdatePatientFamilyHistoryMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c20ef5145477cef7cb3f852e0898e9c6";

export default node;
